import React, { useEffect, useState } from 'react';
import ReservationDetail from './components/ReservationDetail';
import { CircularProgress, Grid } from '@material-ui/core';
import { useBookingAgenda, useBookingAgendaFunctions } from './contexts/BookingAgendaContext';
import StyledAgenda from '../StyledAgenda';

function BookingAgenda({ onLoaded, stepsLoading, transferOpen }) {
  const { appointments, isLoadingMonitorAgenda } = useBookingAgenda();
  const { chooseAppointment } = useBookingAgendaFunctions();

  const [isReservationModalOpen, setIsReservationModalOpen] = useState(false);

  const isLoading = isLoadingMonitorAgenda || stepsLoading;

  useEffect(() => {
    if (isLoadingMonitorAgenda) return;

    onLoaded(appointments);
    // eslint-disable-next-line
  }, [appointments, isLoadingMonitorAgenda, onLoaded]);

  const onAppointmentClick = (e) => {
    const {
      event: { extendedProps },
    } = e;
    chooseAppointment(extendedProps.data);
    setIsReservationModalOpen(true);
  };

  const handleClose = (event) => {
    event.preventDefault();
    setIsReservationModalOpen(false);
    chooseAppointment(null);
  };

  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        {isLoading && (
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              height: '50vh',
            }}
          >
            <CircularProgress />
          </div>
        )}

        {!isLoading && (
          <StyledAgenda
            transferOpen={transferOpen}
            events={appointments}
            initialView={'dayGridMonth'}
            eventClick={onAppointmentClick}
            selectMirror={true}
          />
        )}

        <ReservationDetail isOpen={isReservationModalOpen} onClose={handleClose} />
      </Grid>
    </Grid>
  );
}

export default BookingAgenda;
